import React from "react";
import { css } from "glamor";

const styles = {
    footer: css({
        marginTop: 40,
        fontSize: 10,
    }),
};

export default props => {
    return (
        <div {...styles.footer}>
            <p>
                © 2019. See <a href={`#${props.termsLink}`}>Terms of Use</a> for
                more information.
            </p>
            <p>
                Certain information, such as Protected Health Information that
                is regulated under US law, should not be uploaded to this
                Platform. Please direct any questions to your legal advisor,
                your Engagement Partner or, for practitioners of the US Firms,
                to the Office of the Chief Confidentiality Officer.
            </p>
            <p>
                Deloitte refers to one or more of Deloitte Touche Tohmatsu
                Limited, a UK private company limited by guarantee
                (&quot;DTTL&quot;), its network of member firms, and their
                related entities. DTTL and each of its member firms are legally
                separate and independent entities. DTTL (also referred to as
                &quot;Deloitte Global&quot;) does not provide services to
                clients. Please see{" "}
                <a href="www.deloitte.com/about">www.deloitte.com/about</a> for
                a more detailed description of DTTL and its member firms.
            </p>
        </div>
    );
};
